import * as React from 'react';
import { styled } from '@mui/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

// this code is outragous compared to how simple creating styled components was in previous versions.
const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        fontSize: 14,
        backgroundColor: theme.styled.paper.background,
        border: 'solid',
        borderColor: theme.styled.paper.border,
        borderWidth: 2,
        padding: 10,
        color: theme.palette.text.primary,
    },
    [`& .${tooltipClasses.arrow}`]: {
        fontSize: 18,
        '&::before': {
            backgroundColor: theme.styled.paper.background,
            border: 'solid',
            borderColor: theme.styled.paper.border,
            borderWidth: 2,
        },
    },
}));

const D3StyleTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        fontSize: 14,
        font: theme.typography.tooltips.font,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        border: 'solid',
        borderColor: theme.palette.info.dark,
        borderWidth: 2,
        padding: 10,
    },
    [`& .${tooltipClasses.arrow}`]: {
        fontSize: 18,
        '&::before': {
            color: '#f5f5f9',
        },
    },
}));

export {
    StyledTooltip as default,
    D3StyleTooltip,
};
